import {Button, Card, styled} from '@mui/material';
import Icon from 'presentation/icons';

const SelectCardList = styled(Card)`
	border: 1px solid transparent;
	min-height: 68px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
`;

const StyledIcon = styled(Icon)`
	flex-shrink: 0;
	margin-left: auto;
`;

const StyledButton = styled(Button)`
	padding: 0;
	margin-right: auto;
	text-decoration: underline;
	font-size: 14px;
	line-height: 1;
	letter-spacing: 0.15px;
	color: ${({theme}) => theme.palette.text.secondary};
`;

export {SelectCardList, StyledIcon, StyledButton};
